import { Box } from 'grommet';

type Option<T extends string> = { label: string; value: T; disabled?: boolean };
export const WizardSegmentedControl = <T extends string>({
  name,
  value,
  options,
  onChange,
}: {
  name: string;
  value?: T;
  options: Option<T>[];
  onChange: (value: T) => void;
}) => {
  const locked = options.some((option) => option.disabled);
  return (
    <Box
      direction="row"
      role="radiogroup"
      aria-label={name}
      border={{ color: '#BBB' }}
      round="8px"
      overflow="hidden"
      alignSelf="start"
    >
      {options.map((option, index) => (
        <label
          key={option.value}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 44,
            padding: '0 14px',
            cursor: option.disabled ? 'not-allowed' : 'pointer',
            borderLeft: index ? '1px solid #BBB' : undefined,
            background: value === option.value ? (locked ? '#F2F2F2' : '#e8eef8') : 'white',
            color: option.disabled ? '#bbb' : value === option.value ? (locked ? '#555' : '#0d48a1') : '#333',
            fontSize: 13,
            fontWeight: value === option.value ? 600 : 400,
          }}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            disabled={option.disabled}
            onChange={() => onChange(option.value)}
            style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', margin: 0, cursor: 'inherit' }}
          />
          {option.label}
        </label>
      ))}
    </Box>
  );
};
